import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';
import { baseReducers, getBaseActions } from "./base";

const name = 'order';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        _set: baseReducers._set,
        requested: baseReducers.requested,
        failed: baseReducers.failed,
        itemReceived: baseReducers.itemReceived,
        itemsReceived: baseReducers.itemsReceived,
        deleteReceived: baseReducers.deleteReceived,
        excelReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            bytes: payload
        }),
        updateReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { _set, requested, failed, itemReceived, itemsReceived, deleteReceived, excelReceived, updateReceived } = slice.actions;

export default slice.reducer;

const { baseSet, baseGet, baseGetAll, baseDelete } = getBaseActions(requested.type, failed.type);

export const set = payload => baseSet(_set.type, payload);

export const get = id => baseGet(name, itemReceived.type, { id });

export const getAll = data => baseGetAll(name, itemsReceived.type, data);

export const remove = ids => baseDelete(name, deleteReceived.type, ids);

export const excel = data => ({
    types: [requested.type, excelReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'excel'),
    payload: data
});

export const update = data => ({
    types: [requested.type, updateReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'update'),
    payload: data
});